module.exports = "/img/rapbeat_logo.png?e92b2f8374f7a5271d6a4889012dd2b3";